import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '"Ya tengo seguro"',
  answer: 'Excelente — permítenos hacer una revisión gratuita. La mayoría de las personas descubren vacíos en su cobertura que no sabían que existían. 15 minutos podrían ahorrarte miles de dólares.'
}, {
  question: '"El seguro es muy caro"',
  answer: 'Trabajamos con múltiples aseguradoras para encontrar una cobertura que se ajuste A TU presupuesto. La póliza correcta podría costar menos de lo que crees — y la que falta podría costarlo todo.'
}, {
  question: '"Puedo hacerlo en línea"',
  answer: 'Puedes — pero las herramientas en línea no te explican lo que estás comprando. Nosotros sí. En lenguaje sencillo. Cara a cara.'
}, {
  question: '"Necesito pensarlo"',
  answer: 'Por supuesto. Pero mientras piensas, tu familia está desprotegida. Una conversación no cuesta nada. No tener cobertura podría costarlo todo.'
}, {
  question: '"No hablo bien inglés"',
  answer: 'Ningún problema — atendemos a nuestra comunidad en inglés Y en español. Ven y te atenderemos con gusto.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-20 bg-white" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <div className="max-w-3xl mx-auto" data-id="element-95">
          <div className="text-center mb-10" data-id="element-96">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-97">
              PREGUNTAS FRECUENTES
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-98">
              Respuestas honestas a tus dudas comunes
            </p>
          </div>

          <div className="space-y-4" data-id="element-99">
            {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-off-white" data-id="element-100">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-101">
                  <span className="font-bold text-navy text-lg" data-id="element-102">
                    {faq.question}
                  </span>
                  <ChevronDown className={`text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-103" />
                </button>

                <AnimatePresence data-id="element-104">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-105">
                      <div className="px-6 pb-5 text-gray-700 text-lg border-t border-gray-100 pt-4" data-id="element-106">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}